import React, {useEffect, useState, useContext, useRef} from 'react';
import {useForm} from 'react-hook-form';
import axios from "axios";

import Pagina, {esMayorOIgualACero} from "../comun/Pagina";
import SelectReactHookForm from "../comun/SelectReactHookForm";
import MensajeValidacion from "../comun/MensajeValidacion";
import { Departamentos, traerCPs, traerMunicipios,buscarCPConMismoNombre, buscarCabeceraMunicipal } from '../comun/Departamentos';

import edificioPeq from '../../img/edificio_peq.png';
import Contexto from '../comun/Contexto';
import PaginaAdelanteAtras from './PaginaAdelanteAtras';
import CPSSelectorCP from '../consulta_por_sitio/CPSSelectorCP';
import SelectorCP from '../comun/SelectorCP';
import SelectReactHookForm2 from '../comun/SelectReactHookForm2';

export default function Pagina1(props) {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);
   
    /* refs y registros de react-hook-form*/
    const {register, handleSubmit, watch, formState: { errors }, setValue} = useForm({defaultValues: {
        selMun: props.idMun,
        selCentroPob: props.idCP
    }});
                 
    /* Render */
    return (
        <PaginaAdelanteAtras
        titulo="¿Dónde te encontrabas cuando sentiste el sismo?"
        imgSrc={edificioPeq}
        imgAlt="Donde estabas"
        handleSubmit={handleSubmit}
        avanzarPagina={props.avanzarPagina}
        retrocederPagina={props.retrocederPagina}
        setState={props.setState}
        explicacion={
            <React.Fragment>
            Es muy importante conocer de manera precisa el sitio en el que te encontrabas cuando ocurrió el sismo.
            <br/>Por favor facilítanos la localización más exacta posible
            </React.Fragment>
        }
        
        contenidoPrincipal= {
            <div style={{ height:"100%"}}>
                <SelectorCP2 urlBaseRest={urlBaseRest} register={register} errors={errors} state={props.state} setValue={setValue}
                idCP={props.idCP} setIdCP={props.setIdCP} 
                idDepto={props.idDepto} setIdDepto={props.setIdDepto} idDeptoRef={props.idDeptoRef}
                idMun={props.idMun} setIdMun={props.setIdMun} idMunRef={props.idMunRef}/>
            </div>            
        }
        />
    );
}

const SelectorCP2 =({urlBaseRest, register, errors, state, setValue, 
idDepto, setIdDepto, idDeptoRef, idMun, setIdMun, idMunRef, idCP, setIdCP})=>{
    const [municipios, setMunicipios] = useState([]);
    const [centrosPoblados, setCentrosPoblados] = useState([]);

    /** refs */    
    const nombreMunRef = useRef(null);
    const nombreCPRef = useRef(null);
        
    const regDepto = register("selDepto", { required: true, validate: esMayorOIgualACero });
    const regMun = register("selMun", { required: false, validate: esMayorOIgualACero });
    const regCP = register("selCentroPob", { required: true, validate: esMayorOIgualACero });   

    /* Efectos */
    useEffect( ()=>{ 
        console.log("efecto de cambio de depto " + idDepto + " vs " +idDeptoRef.current)
        if (idDeptoRef.current != idDepto) {   
            console.log("cambie mun")         
            setIdMun(-1);
            setValue(regMun.name, -1)
        }

        idDeptoRef.current = idDepto;
        traerMunicipios(urlBaseRest, idDepto, setMunicipios);
    }, [idDepto] );

    useEffect( ()=>{ 
        console.log("efecto de cambio de idmun invocado " + idMun +" vs " + idMunRef.current)
        if (idMunRef.current != idMun) {            
            setIdCP(-1);
            setValue(regCP.name, -1)
        }

        idMunRef.current = idMun
        traerCPs(urlBaseRest, idMun, setCentrosPoblados) 
    }, [idMun] );   

    useEffect( ()=>{ 
        //let cp = buscarCPConMismoNombre( nombreMunRef.current, centrosPoblados);
        let cp = buscarCabeceraMunicipal(centrosPoblados);
        if (cp != null) {
            setIdCP(cp.codigo);
            setValue(regCP.name,cp.codigo);
            nombreCPRef.current=cp.nombre;
        }
    }, [centrosPoblados]);

    // Handlers de evento de cambio de selects
    const handleChangeDepto = (e) => {
        //console.log("cambiando depto")
        setIdDepto(e.target.value);
    };

    const handleChangeMun = (e) => {    
        //console.log("cambiando mun")
        setIdMun(e.target.value);
        nombreMunRef.current = e.target[e.target.selectedIndex].text;        
    };

    const handleChangeCP= (e) => {
        //console.log("cambiando cp")
        setIdCP(e.target.value);        
        nombreCPRef.current = e.target[e.target.selectedIndex].text;   
    };    
    console.log("rendereando selector ")    
    //console.log("municipios2")
    //console.log(municipios2)
    //console.log("idMun " +  idMun)
    //console.log("idCP  " + idCP)
    return (
        <div style = {{display:"flex", flexDirection:"column", height:"100%", 
        justifyContent:"center"}}>
            <div className='CajaToponimo'>
                <div className="TextoMedianoVerde" >Departamento</div>               
                <SelectReactHookForm2 reg={regDepto} handleChange={handleChangeDepto} opciones={Departamentos} valor={idDepto}/>
                <MensajeValidacion nombre={regDepto.name} errors={errors}/>
            </div>

            <div className='CajaToponimo'>
                <div className="TextoMedianoVerde">Municipio</div>
                <SelectReactHookForm2 reg={regMun} handleChange={handleChangeMun} opciones={municipios} valor={idMun}/>
                <MensajeValidacion nombre={regMun.name} errors={errors}/>
            </div>

            <div className='CajaToponimo'>
                <div className="TextoMedianoVerde">Centro poblado</div>
                <SelectReactHookForm2 reg={regCP} handleChange={handleChangeCP} opciones={centrosPoblados} valor={idCP}/>
                <MensajeValidacion nombre={regCP.name} errors={errors}/>
            </div>

            <div className='CajaToponimo'>
                <div className="TextoMedianoVerde">Dirección aproximada</div>
                <input type="text"defaultValue={state.direccion} placeholder="(Por ejemplo: Calle 5 con carrera 2)"
                {...register("direccion", {required: true})} className="InputTexto"/>
                <MensajeValidacion nombre="direccion" errors={errors}/>
            </div>
        </div>
    )
}